import { ConfigurationService } from '../configuration/configuration.service';
import { ConsoleHandler } from './console.logger';
import { LogLevelEnum, LoggerHandler } from './logger.types';
import { RemoteHandler } from './remote.logger';

export class Logger {
  private static handler: LoggerHandler = Logger.getDefaultHandler();

  private static readonly logLevel: LogLevelEnum = Logger.getLogLevel();

  static getDefaultHandler(): LoggerHandler {
    return globalThis.DELMONICOS_ENV.DELMONICOS_DISABLE_REMOTE_LOGGING?.toUpperCase() ===
      'TRUE'
      ? ConsoleHandler
      : RemoteHandler;
  }

  static setHandler(handler: LoggerHandler): void {
    Logger.handler = handler;
  }

  static getLogLevel(): LogLevelEnum {
    const processLogLevel = ConfigurationService.getLogLevel() ?? 'INFO';

    return (
      LogLevelEnum[processLogLevel as keyof typeof LogLevelEnum] ??
      LogLevelEnum.INFO
    );
  }

  static log(logLevel: LogLevelEnum, ...parameters: any[]): void {
    if (logLevel >= Logger.logLevel) {
      Logger.handler(logLevel, ...parameters);
    }
  }

  static debug(...parameters: any[]): void {
    Logger.log(LogLevelEnum.DEBUG, ...parameters);
  }

  static info(...parameters: any[]): void {
    Logger.log(LogLevelEnum.INFO, ...parameters);
  }

  static warn(...parameters: any[]): void {
    Logger.log(LogLevelEnum.WARN, ...parameters);
  }

  static error(...parameters: any[]): void {
    Logger.log(LogLevelEnum.ERROR, ...parameters);
  }
}
